<style scoped>
.deals-title {
  vertical-align: middle;
}

.deals-summary {
  padding: 0px 0px 10px 0px;
  border-bottom: 1px rgb(222, 226, 230) solid;
}
</style>

<template>
  <div>
    <header class="spaced-header bg-light">
      <b-col class="text-center text-light-blue">
        <b-img :src="icon" fluid alt="Responsive image" class="mr-2"/>
        <span class="h3 deals-title">
          {{ title | uppercase }} LOANS - SUMMARY
        </span>
      </b-col>
    </header>
    <div>
      <b-row>
        <b-col>
          <div class="text-right mb-2">
            <b-form-checkbox
              switch
              name="switch-search-mode"
              class="switch-pointer-cursor"
              v-model="searchMode"
            >
              Search Mode
            </b-form-checkbox>
          </div>
          <loan-search
            v-if="searchMode"
            @amount-updated="totalAmount = $event"
            @count-updated="totalCount = $event"
          />
          <loan-tables-container
            v-else
            :category="selectedCategory"
            @index-updated="(index, category) => (selectedCategory = category)"
            @amount-updated="totalAmount = $event"
            @count-updated="totalCount = $event"
            ref="loansTableView"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import LoanTablesContainer from '@/components/my_deals/deals/LoanTablesContainer';
import LoanSearch from '@/components/my_deals/deals/LoanSearch';
import DashboardButton from '@/components/utils/buttons/navigation/DashboardButton';
import DocumentsButton from '@/components/utils/buttons/navigation/DocumentsButton';
import EmailButton from '@/components/utils/buttons/misc/EmailButton';
import { MYDOCS_READ } from '@/libs/permissions_list';


export default {
  components: {
    LoanTablesContainer,
    LoanSearch,
    DashboardButton,
    DocumentsButton,
    EmailButton,
  },
  props: {
    category: String,
  },
  data: () => ({
    searchMode: false,
    selectedCategory: 'in_progress',
    totalAmount: null,
    totalCount: null,
    table: { category: 'in_progress', totalAmount: null, totalCount: null },
    permissionList: [MYDOCS_READ],

  }),
  watch: {
    searchMode() {
      this.totalAmount = null;
      this.totalCount = null;
    },
  },
  computed: {
    title() {
      if (this.searchMode) {
        return 'SEARCH';
      }

      const tableCategoryMap = {
        in_progress: 'PENDING',
        active: 'ACTIVE',
        paid: 'PAID',
        all: 'ALL',
      };
      return tableCategoryMap[this.selectedCategory];
    },
    icon() {
      switch (this.selectedCategory) {
        case 'in_progress':
          return './static/my_deals/active-deals-icon.png';
        case 'paid':
          return './static/my_deals/paid_icon.png';
        default:
          return './static/my_deals/progress_icon.png';
      }
    },
  },
  created() {
    this.selectedCategory = this.$route.query.category;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/deals/MyDeals.vue